import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './component/modal/modal.component';
import { PolicyAdminDownComponent } from './component/policy-admin-down/policy-admin-down.component';
import { FormStateService } from './services/form-state.service';

@NgModule({
  imports: [FormsModule, CommonModule, ReactiveFormsModule],
  exports: [ModalComponent, PolicyAdminDownComponent],
  declarations: [ModalComponent, PolicyAdminDownComponent],
  providers: [FormStateService],
})
export class WidgetCommonModule {}
